import { AUTH_CALLBACK_ERRORS } from "./constants/common";

// utils/decodeJwt.ts
export const decodeJwt = <T = any>(token: string): T | null => {
  try {
    const payload = token.split(".")[1];
    if (!payload) return null;

    // Base64URL → Base64
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");

    // Decode & parse
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join(""),
    );

    return JSON.parse(jsonPayload) as T;
  } catch (error) {
    return null;
  }
};

export const getAuthCallBackErrorMessage = (errorType: string) => {
  switch (errorType) {
    case AUTH_CALLBACK_ERRORS.SECURITY_RISK:
      return "Authentication failed due to security risk. Please contact Admin.";
    case AUTH_CALLBACK_ERRORS.ACCOUNT_DELETED:
      return "Failed to signing. Your account has been deleted. Please contact Admin.";
    case AUTH_CALLBACK_ERRORS.UNAUTHORIZED:
      return "You are not authorized to access this application, Please contact Admin.";
    case AUTH_CALLBACK_ERRORS.LOGIN_FAILED:
      return "Login failed. Please try again.";
    case AUTH_CALLBACK_ERRORS.ACCOUNT_INACTIVE:
      return "Your account is inactive. Please contact Admin.";
    default:
      return "Authentication failed. Please try again.";
  }
};
